/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ age: NonNullable<unknown> }} Minagebadge2Inputs */

const en_minagebadge2 = /** @type {(inputs: Minagebadge2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.age}+`)
};

const de_minagebadge2 = /** @type {(inputs: Minagebadge2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.age}+`)
};

/**
* | output |
* | --- |
* | "{age}+" |
*
* @param {Minagebadge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const minagebadge2 = /** @type {((inputs: Minagebadge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minagebadge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minagebadge2(inputs)
	return de_minagebadge2(inputs)
});
export { minagebadge2 as "minAgeBadge" }